<template>
<v-container>
  <v-row dense>
    <v-col cols="12">
      <v-card color="basil" flat outlined>
        <v-card-title v-if="customer.id">
          <h3 class="font-weight-bold text-uppercase" >{{customer.NombreCompleto}}</h3>
        </v-card-title>
        <v-card-subtitle>
          <h4 class="font-weight-bold" ><span class="black--text">Tel.:</span> {{customer.telefono}}</h4>
          <h4 class="font-weight-bold" ><span class="black--text">Correo:</span> {{customer.correo}}</h4>
        </v-card-subtitle>

        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-btn-toggle v-model="credito.tipoCredito" class="buttonBorder" @change="chengeItem"
                color="deep-purple accent-3 pa-4" tile dense group>
                <v-btn value="bancario"> BANCARIO </v-btn>
                <v-btn value="cofinavit"> COFINAVIT </v-btn>
                <!-- <v-btn value="fovissste"> FOVISSSTE </v-btn> -->
              </v-btn-toggle>
            </v-col>

            <v-col cols="6">
              <h3 class="text-center black--text title">DATOS DEL CRÉDITO</h3>
              <v-row dense class="black--text font-weight-bold">
                <v-col :cols="(cofinavit)? 11 : 7">
                  <v-text-field
                    v-model.number="credito.precioVivienda"
                    prefix="$"
                    label="PRECIO VIVIENDA"
                    :rules="fieldRequired"
                    type="number"
                    min="0"
                    :readonly="isreadonly"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="4" v-if="bancario">
                  <v-text-field
                    v-model.number="credito.porcentajeCredito"
                    label="PORCENTAJE CREDITO"
                    :rules="fieldRequired"
                    type="number"
                    suffix="%"
                    min="0"
                    :readonly="isreadonly"
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="11" v-if="bancario">
                  <v-text-field
                    v-model="EngancheCliente"
                    label="ENGANCHE DEL CLIENTE"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense/>
                </v-col>
                <v-col cols="11" v-if="bancario">
                  <v-text-field
                    v-model="credito.engancheAdicional"
                    label="ENGANCHE ADICIONAL"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    outlined
                    dense/>
                </v-col>
                <v-col cols="11" v-if="bancario">
                  <v-text-field
                    v-model="EngancheTotal"
                    label="TOTAL ENGANCHE"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense/>
                </v-col>

                <v-col cols="11" v-if="cofinavit">
                  <v-text-field
                    v-model.number="credito.creditoInfonavit"
                    label="CREDITO INFONAVIT"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    :readonly="isreadonly"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="11" v-if="cofinavit || fovissste">
                  <v-text-field
                    v-model.number="credito.subCuentaVivienda"
                    label="SUBCUENTA VIVIENDA"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    :readonly="isreadonly"
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="11" v-if="cofinavit">
                  <v-text-field
                    v-model.number="credito.enganche"
                    label="ENGANCHE"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    :readonly="isreadonly"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="11" v-if="fovissste">
                  <v-text-field
                    v-model.number="EngancheFovissste"
                    label="ENGANCHE"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="11">
                  <v-text-field
                    label="CREDITO DEL BANCO"
                    v-model="CreditoBancoRequerido"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense/>
                </v-col>
                <v-col cols="11" v-if="fovissste">
                  <v-text-field
                    label="RECURSOS TOTALES"
                    v-model="RecursosTotales"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense/>
                </v-col>
                <v-col cols="11">
                  <v-text-field
                    label="INGRESO NETO MINIMO DEL CLIENTE"
                    v-model="IngresoNetoMinimo"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense/>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="6">
              <h3 class="text-center black--text title">GASTOS DEL CRÉDITO</h3>
              <v-row dense class="black--text font-weight-bold">

                <v-col cols="11">
                  <v-text-field
                    label="GASTO DE ESCRITURA"
                    v-model="CostosEscritura"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="11">
                  <v-text-field
                    label="COSTO DE AVALUO APROX."
                    v-model="CostoAvaluo"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="5" v-if="bancario || cofinavit">
                  <v-text-field
                    label="COMISION APERTURA"
                    v-model="ComisionBancaria"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="6" v-if="bancario || cofinavit">
                  <v-select
                    v-model="credito.porcentajeComisionBanco"
                    :items="get_porcentajeAvaluo"
                    label="PORCENTAJE COMISION"
                    suffix="%"
                    item-text="name"
                    item-value="val"
                    :readonly="isreadonly"
                    outlined
                    dense>
                  </v-select>
                </v-col>

                <v-col cols="11">
                  <v-text-field
                    label="TOTAL GASTOS CREDITO"
                    v-model="TotalgastosCredito"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense
                  />
                </v-col>

                <v-col cols="11" v-if="bancario || cofinavit">
                  <v-text-field
                    label="ENGANCHE CLIENTE + GASTOS"
                    v-model="EngancheGastos"
                    :rules="fieldRequired"
                    type="number"
                    prefix="$"
                    min="0"
                    readonly
                    outlined
                    dense
                  />
                </v-col>

              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <v-toolbar dense dark color="blue darken-2">
                <v-toolbar-title>
                  <h3 class="text-center text-p">COMPARATIVO CRÉDITO BANCARIO</h3>
                </v-toolbar-title>
                <v-spacer/>
                <v-row dense no-gutters>
                  <v-layout justify-end>
                    <v-flex sm6 class="pt-6">
                      <SelectedMain :itemAction="fieldPlazo" :on-success="actionFieldData"/>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-toolbar>
              <v-simple-table class="elevation-3">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="black--text">BANCO</th>
                      <th class="black--text">TASA</th>
                      <th class="black--text">INTERES</th>
                      <th class="black--text">CAPITAL</th>
                      <th class="black--text">SEGURO VIDA</th>
                      <th class="black--text">SEGURO DAÑOS</th>
                      <th class="black--text">COMISION</th>
                      <th class="black--text">MENSUALIDAD</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in credito.generateTable" :key="index">
                      <td class="black--text">{{ item.banco.nombre }}</td>
                      <td>{{ item.banco.tasa_nombre }}</td>
                      <td>{{ intlRound(item.calculo.interes) }}</td>
                      <td>{{ intlRound(item.calculo.capital) }}</td>
                      <td>{{ intlRound(item.calculo.seguroVida) }}</td>
                      <td>{{ intlRound(item.calculo.seguroDanios) }}</td>
                      <td>{{ intlRound(item.banco.comision) }}</td>
                      <td class="black--text">{{ intlRound(item.calculo.mensualidad) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12" class="mt-3">
              <v-layout justify-center>
                <v-flex md10>
                  <p class="text-p font-weight-bold"> *Son Tasas promedio por cada institución, la tasa puede bajar y subir de acuerdo al análisis de riesgo por parte del banco. Consulta con un asesor</p>
                  <p class="text-p font-weight-bold"> *Información para fines informativos y de comparación exclusivamente </p>
                </v-flex>
              </v-layout>
            </v-col>
            <v-col cols="6" v-if="false">
              <v-checkbox v-model="credito.correo" label="Enviar Correo"> </v-checkbox>
            </v-col>
            <v-col cols="12" class="mt-3">
              <v-textarea
                v-model="credito.comentarios"
                name="input-7-4"
                label="Comentarios"
                :readonly="isreadonly"
                dense
                outlined>
              </v-textarea>
            </v-col>
            <v-col cols="12" class="pt-4">
              <v-layout justify-center>
                <v-flex xs10 sm6 md7>
                  <v-card tile>
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="12">
                          <img width="100%" src="@/assets/images/main2.jpg"/>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-col>

            <v-col v-if="false" cols="6">
              <v-btn class="yellow darken-3 mr-3" dark @click="sendEmail"> Enviar Simulación de Crédito </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-end class="px-4">
            <v-btn color="red darken-2" class="mr-4" @click="cancel" dark> Salir </v-btn>
            <v-btn color="green darken-2" @click="send" dark> Guardar </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>

</v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import { NumberUtils } from '@/mixins/NumberUtilsMixin'
import SelectedMain from '@/components/fields/SelectedMain'
import router from '@/router'
export default {
  name: 'FormCustomer',
  mixins: [Validate, NumberUtils],
  data: () => ({
    tab: 0,
    credito: {
      tipoCredito: 'bancario',
      precioVivienda: 0,
      porcentajeCredito: 0,
      engancheAdicional: 0,
      porcentajeComisionBanco: '1',

      creditoInfonavit: 0,
      subCuentaVivienda: 0,
      enganche: 0,

      generateTable: [],
      comentarios: '',
      correo: false
    },
    bancario: true,
    cofinavit: false,
    fovissste: false,
    fieldPlazo: { name: 'Plazos', nameid: 'plazo', url: '/config/deadlines/group', itemValue: 'plazo', rules: true, cols: 12 },

    showProgress: false,
    isreadonly: false,
    customer: {},
    customer_id: 0
  }),
  components: {
    SelectedMain
  },
  mounted () {
    if (this.$route.params.id) {
      this.customer_id = this.$route.params.id
      this.PostObject({ url: '/clientes', data: { id: this.customer_id } })
    }
  },
  methods: {
    ...mapActions(['PostObject', 'PostObjectSeccound', 'PostListObjects']),
    ...mapMutations(['SET_PROGRESS_EMAIL']),
    chengeItem (item) {
      if (item === 'bancario') {
        this.bancario = true
        this.cofinavit = false
        this.fovissste = false
      }
      if (item === 'cofinavit') {
        this.cofinavit = true
        this.bancario = false
        this.fovissste = false
      }
      if (item === 'fovissste') {
        this.fovissste = true
        this.bancario = false
        this.cofinavit = false
      }
    },
    actionFieldData (obj) {
      if (obj.data) {
        this.PostListObjects({ url: '/config/deadlines', data: { [obj.id]: obj.data, tipo: 'CREDITO BANCARIO' } })
      }
      this.credito[obj.id] = obj.data
    },
    tabla (plazo) {
      if (this.CreditoBancoRequerido > 0 && this.credito.precioVivienda > 0) {
        const interes = ((this.CreditoBancoRequerido * (plazo.banco.tasa / 100)) * plazo.banco.dias_mes) / plazo.banco.dias_anio
        const capital = this.CreditoBancoRequerido * plazo.capital
        const seguroVida = this.CreditoBancoRequerido * plazo.seguroVida
        const seguroDanios = this.credito.precioVivienda * plazo.banco.seguroddanios
        const comision = parseFloat(plazo.banco.comision)
        const mensualidad = interes + capital + seguroVida + seguroDanios + comision
        return {
          interes: interes,
          capital: capital,
          seguroVida: seguroVida,
          seguroDanios: seguroDanios,
          mensualidad: mensualidad
        }
      }
      return {
        interes: 0,
        capital: 0,
        seguroVida: 0,
        seguroDanios: 0,
        mensualidad: 0
      }
    },
    send () {
      if (this.credito.tipoCredito === '') {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia !',
          text: 'Tipo de credito no debes ser seleccionado'
        })
        return
      }
      this.credito.cliente_id = this.customer_id
      this.PostObjectSeccound({ url: '/clientes/credito/tipo-credito', data: this.credito })
    },
    cancel () {
      router.push({ name: 'ViewCustomers' })
    },
    sendEmail () {
      this.credit.correo = {
        ingresosAdeudos: this.intlRound(this.totalIngresosMenostotalAdeudos),
        creditoAprox: this.intlRound(this.CreditoAprox),
        pagoDisponible: this.intlRound(this.pagoDisponible),
        creditoBancoReq: this.intlRound(this.creditoBancoRequerido),
        enganche: this.intlRound(this.engancheGastos),
        gastos: this.intlRound(this.gastos),
        table: this.generateTable
      }
      this.SET_PROGRESS_EMAIL(true)
      // console.log('send', this.credit)
      this.ResendEmail(this.credit)
    },
    validMonto (monto) {
      return (monto > 0) ? monto : 0
    }
  },
  computed: {
    ...mapGetters(['get_object', 'get_objectSeccound', 'get_objects', 'get_porcentajeAvaluo']),
    // *==========*==========*==========*==========*==========*==========*==========*==========* \\
    // *==========*==========*==========*   Tipo de Credito   *==========*==========*==========* \\
    // *==========*==========*==========*==========*==========*==========*==========*==========* \\
    EngancheCliente () {
      const valorVivienda = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
      const porcentajeCredito = (this.credito.porcentajeCredito === '') ? 0 : parseFloat(this.credito.porcentajeCredito)
      const enganche = valorVivienda - (valorVivienda * (porcentajeCredito / 100))
      return (enganche <= 0) ? 0 : enganche
    },
    EngancheTotal () {
      const engancheAdicional = (this.credito.engancheAdicional === '') ? 0 : parseFloat(this.credito.engancheAdicional)
      const enganche = this.EngancheCliente + engancheAdicional
      return (enganche <= 0) ? 0 : enganche
    },
    CreditoBancoRequerido () {
      if (this.credito.tipoCredito === 'bancario') {
        const valorVivienda = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
        const porcentajeCredito = (this.credito.porcentajeCredito === '') ? 0 : parseFloat(this.credito.porcentajeCredito)
        const engancheAdicional = (this.credito.engancheAdicional === '') ? 0 : parseFloat(this.credito.engancheAdicional)

        return (valorVivienda * (porcentajeCredito / 100) - engancheAdicional)
      } else if (this.credito.tipoCredito === 'cofinavit') {
        const valorVivienda = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
        const creditInfonavit = (this.credito.creditoInfonavit === '') ? 0 : parseFloat(this.credito.creditoInfonavit)
        const subCuentaVivienda = (this.credito.subCuentaVivienda === '') ? 0 : parseFloat(this.credito.subCuentaVivienda)
        const enganche = (this.credito.enganche === '') ? 0 : parseFloat(this.credito.enganche)

        return (valorVivienda - (creditInfonavit + subCuentaVivienda + enganche))
      } else if (this.credito.tipoCredito === 'fovissste') {
        const valorVivienda = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
        return (valorVivienda * 0.95)
      }
      return 0
    },
    IngresoNetoMinimo () {
      if (this.credito.tipoCredito === 'bancario') {
        const creditoBanco = this.CreditoBancoRequerido
        const neto = (((creditoBanco * 9.5) / 1000) * 1.7)
        return (neto <= 0) ? 0 : neto
      } else if (this.credito.tipoCredito === 'cofinavit') {
        const creditoBanco = this.CreditoBancoRequerido
        const neto = (((creditoBanco * 9.5) / 1000) * 1.7)
        return (neto <= 0) ? 0 : neto
      } else if (this.credito.tipoCredito === 'fovissste') {
        const creditoBanco = this.CreditoBancoRequerido
        const neto = (((creditoBanco * 8.8) / 1000) * 1.55)
        return (neto <= 0) ? 0 : this.round(neto)
      }
      return 0
    },
    CostosEscritura () {
      const valorVivienda = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
      if (valorVivienda > 0) {
        const escrita = valorVivienda * (6 / 100)
        return escrita
      }
      return 0
    },
    CostoAvaluo () {
      const valorVivienda = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
      if (valorVivienda > 0) {
        const avaluo = valorVivienda * 0.0035
        return avaluo
      }
      return 0
    },
    ComisionBancaria () {
      const creditoBanco = this.CreditoBancoRequerido
      const porcentajeComision = (this.credito.porcentajeComisionBanco) ? parseFloat(this.credito.porcentajeComisionBanco) : 0
      console.log('porcentajeComision', porcentajeComision)
      if (creditoBanco > 0) {
        const comBanc = creditoBanco * (porcentajeComision / 100)
        return comBanc
      }
      return 0
    },
    TotalgastosCredito () {
      if (this.credito.tipoCredito === 'fovissste') {
        return (this.CostosEscritura + this.CostoAvaluo)
      }
      return (this.CostosEscritura + this.CostoAvaluo + this.ComisionBancaria)
    },
    EngancheGastos () {
      if (this.credito.tipoCredito === 'bancario') {
        const totalengancClient = this.EngancheTotal + this.TotalgastosCredito
        return totalengancClient
      } else if (this.credito.tipoCredito === 'cofinavit') {
        const enganche = (this.credito.enganche === '') ? 0 : parseFloat(this.credito.enganche)
        const totalgastosCredito = this.TotalgastosCredito
        const totalEnganche = enganche + totalgastosCredito
        return totalEnganche
      } else if (this.credito.tipoCredito === 'cofinavit') {
        const enganche = (this.credito.enganche === '') ? 0 : parseFloat(this.credito.enganche)
        const totalgastosCredito = this.TotalgastosCredito
        const totalEnganche = enganche + totalgastosCredito
        return totalEnganche
      }
      return 0
    },
    RecursosTotales () {
      const creditoBanco = this.CreditoBancoRequerido
      const v = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
      const subCV = (this.credito.subCuentaVivienda === '') ? 0 : parseFloat(this.credito.subCuentaVivienda)
      const enganche = (v - subCV - creditoBanco)

      const subCuentaVivienda = (this.credito.subCuentaVivienda === '') ? 0 : parseFloat(this.credito.subCuentaVivienda)
      return (creditoBanco + enganche + subCuentaVivienda)
    },
    EngancheFovissste () {
      const valorVivienda = (this.credito.precioVivienda === '') ? 0 : parseFloat(this.credito.precioVivienda)
      const subCuentaVivienda = (this.credito.subCuentaVivienda === '') ? 0 : parseFloat(this.credito.subCuentaVivienda)
      const creditoBanco = this.CreditoBancoRequerido
      const enganche = (valorVivienda - subCuentaVivienda - creditoBanco)

      return (enganche <= 0) ? 0 : enganche
    }
  },
  watch: {
    get_object (val) {
      if (val) {
        this.customer = val
      }
    },
    get_objects (vals) {
      if (vals) {
        this.credito.generateTable = []
        const bancos = vals
        bancos.map(plazo => {
          plazo.calculo = this.tabla(plazo)
        })
        this.credito.generateTable = bancos
      }
    },
    get_objectSeccound (val) {
      if (val.message) {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso !',
        text: 'Registro agregado correctamente',
        time: 1500
      })
      this.cancel()
    }
  }
}
</script>

<style>
.buttonBorder button {
  border: 1px #1976D2 solid !important;
  color: #1976D2 !important;
  font-weight: bold;
}
.text-p {
  margin: 0 auto;
}
.right-number {
  float: right;
}
.cuadro-blue {
  border: 1px #1976D2 solid !important;
  padding: 5px;
}
</style>
